export enum TicketFilterType {
    All = "all",
    Your = "your",
    New = "new",
    Deleted = "deleted",
    Finalized = "finalized",
    Unread = "unread"
}